<div class="container-fluid fill-height">
    <div class="row">
        <div class="pnl-header col-12">
            <app-header></app-header>
        </div>
        <div class="pnl-content col-12" style="padding-left:0; padding-right:0">
            <div class="containerthankyoupage">
                <div class="col-lg-8 col-md-8 col-sm-12" style="margin:auto;">
                    <h1>Thank You!</h1>
                    <br />
                    <p style="margin-bottom:0;">Depending on the volume of events being processed, it can take up to 5-10 days for your event to
                        appear on our websites.</p>
                    <p>Please submit your event in plenty of time to allow it maximum exposure
                            on our site.</p>
                </div>
            </div>

            <br /><br />
            <!-- <a [routerLink]="['/register-event']">Register Another Event</a> -->
            <button mat-button class="btn btn-default btn-register" [routerLink]="['/register-event']" aria-label="Register Another Event" matTooltip="Register Another Event">Register Another
                Event</button>
        </div>
        <div class="pnl-footer col-12">
            <app-form-footer></app-form-footer>
        </div>
    </div>
</div>